export default {
  expiresSoon: 'The trail of \'{appName}\' will be deactivated after {expiryDate}.',
  pinApp: 'Pin the app to the navigation bar',
  unpinApp: 'Remove the app from the navigation bar',
};
